import { partnersData } from '@/mocks/homeData';
import { SectionTag, SectionTitle } from '@/components/base/Card';

export default function PartnersSection() {
  return (
    <section className="section-padding bg-background-100">
      <div className="container-custom">
        <div className="text-center mb-12">
          <SectionTag>合作伙伴</SectionTag>
          <SectionTitle>全球顶级机构信赖之选</SectionTitle>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-1">
          {partnersData.map((partner) => (
            <div
              key={partner.slug}
              className="flex items-center justify-center p-6 md:p-8 border border-background-200/50 bg-background-50/60 hover:bg-background-50 transition-colors duration-300 cursor-pointer"
            >
              <span className="font-heading text-base md:text-lg text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                {partner.name}
              </span>
            </div>
          ))}
        </div>

        <p className="text-center mt-10 text-sm text-foreground-500">
          以上为部分合作伙伴，排名不分先后
        </p>
      </div>
    </section>
  );
}